import { scoreCategory } from "../scoring";
import type {
  YachtCategory,
  YachtGameState,
  YachtScorePreview,
  YachtScoringDice,
} from "../types";
import { YACHT_CATEGORIES } from "../types";
import { toScoringDice } from "../utils";

function pickRecommended(
  previews: readonly Omit<YachtScorePreview, "recommended">[],
): readonly YachtScorePreview[] {
  const bestScore = Math.max(...previews.map((preview) => preview.score));
  return previews.map((preview) => ({
    ...preview,
    recommended: preview.score === bestScore && bestScore > 0,
  }));
}

export function selectOpenCategories(
  state: YachtGameState,
  playerId: string,
): readonly YachtCategory[] {
  const scoreSheet = state.scoreSheetsByPlayerId[playerId];
  if (!scoreSheet) return [];
  return YACHT_CATEGORIES.filter(
    (category) => scoreSheet.entries[category] === undefined,
  );
}

export function previewScoresForDice(
  categories: readonly YachtCategory[],
  dice: YachtScoringDice,
): readonly YachtScorePreview[] {
  return pickRecommended(
    categories.map((category) => ({
      category,
      score: scoreCategory(category, dice),
    })),
  );
}

export function selectScorePreviews(
  state: YachtGameState,
  playerId: string,
): readonly YachtScorePreview[] {
  const slot = state.turnSlotsByPlayerId[playerId];
  if (!slot || slot.status !== "OPEN" || slot.rollCount === 0) return [];
  const dice = toScoringDice(slot.dice);
  if (!dice) return [];
  return previewScoresForDice(selectOpenCategories(state, playerId), dice);
}
